<script>
import OrgaoApreensorService from '../../../../domain/bem-equipamento/services/index'
import CategoriasVeicularesService from '../../../../domain/bem-categoria/services/categorias-veiculares'
import { isArray } from 'lodash'

export default {
  components: {},
  nome: 'novo-bem-equipamento',
  data () {
    return {
      isLoading: false,
      isLoaded: false,
      cadastroError: null,
      atualizadoSucesso: null,
      categoriasDisponiveis: [], // Categorias carregadas da API
      novaCategoriaId: null,     // Categoria que o usuário seleciona para adicionar
      data: {
        id: null,
        nome: null,
        excluido: false,
        policiaCivil: false,
        categoriaIds: []
      }
    }
  },
  computed: {
  },
  mounted () {
    this.start()
    this.carregarCategorias()
  },
  activated () {
  },
  destroyed () {
  },
  watch: {},
  methods: {
    start () {
      if (this.$route.params.id) {
        this.$loaderOverlay.open().message('Carregando')
        OrgaoApreensorService.find(this.$route.params.id, true)
          .then((response) => {
            this.isLoaded = true
            this.$loaderOverlay.hide()
            this.data = response.data

            // Se as categorias já estiverem no objeto data, preencha categoriaIds
            if (Array.isArray(this.data.categorias)) {
              this.data.categoriaIds = this.data.categorias.map(categoria => categoria.id)
            }

            console.log('Dados carregados:', response)
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      } else {
        this.isLoaded = true
        // this.$loaderOverlay.open().message('Aguarde')
      }
    },
    carregarCategorias () {
      // Carrega as categorias da API
      CategoriasVeicularesService.list(10, 1)
        .then((response) => {
          this.categoriasDisponiveis = response.data.result
          console.log('Categorias carregadas:', this.categoriasDisponiveis)
        })
        .catch((error) => {
          console.error('Erro ao carregar categorias:', error)
        })
    },
    adicionarCategoria () {
      console.log('Tentando adicionar categoria:', this.novaCategoriaId)
      console.log('Categorias já aficionados:', this.data.categoriaIds)

      // Verifique se `categoriaIds` é um array e inicialize se não for
      if (!Array.isArray(this.data.categoriaIds)) {
        this.data.categoriaIds = []
      }

      if (
        this.novaCategoriaId &&
        !this.data.categoriaIds.includes(this.novaCategoriaId)
      ) {
        this.data.categoriaIds.push(this.novaCategoriaId)
        console.log('Categoria aficionado com sucesso:', this.data.categoriaIds)
        this.novaCategoriaId = null
      } else {
        console.log('Categoria já existe ou não é válida.')
      }
    },
    removerCategoria (id) {
      // Remove o ID da categoria do array `categoriaIds`
      this.data.categoriaIds = [...this.data.categoriaIds.filter(categoriaId => categoriaId !== id)]

      // Atualize a lista de categorias exibidas
      this.categoriasDisponiveis = this.categoriasDisponiveis.map(categoria => {
        if (categoria.id === id) {
          categoria.selected = false // Adicione um estado de seleção, se necessário
        }
        return categoria
      })

      console.log('Categoria removida, categorias restantes:', this.data.categoriaIds)
    },
    submit () {
      this.cadastroError = null
      this.atualizadoSucesso = false
      this.$loaderOverlay.open().message('Processando...')
      this.$bar.start()
      window.setTimeout(() => {
        this.$loaderOverlay.message('Aguarde...')
      }, 1000)
      OrgaoApreensorService.cadastrar(this.data, this.$route.params.id).then((response) => {
        let callbackEnd = () => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          if (this.$route.params.id) {
            // Continua na mesma tela de edição
            // this.$nextTick(() => {
            this.start()
            this.atualizadoSucesso = true
            this.$el.querySelector('#sucessMsg').focus()
            // })
          } else {
            // Redirecionr para tela de visualização
            // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
            this.atualizadoSucesso = true
          }
        }
        callbackEnd()
      }).catch((response) => {
        this.$bar.finish()
        this.$loaderOverlay.hide()
        this.cadastroError = response.data.errors
        this.$nextTick(() => {
          this.$refs.error.focus()
        })
        console.log(response)
      })
    },
    printError (err) {
      if (isArray(err)) {
        return err[0]
      }
      return err
    }
  }
}
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Equipamento</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'config.bem-equipamento.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p>{{ cadastroError }}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome"/>
                </div>
              </div>

              <div class="form-group">
                <label for="tipo-impeditiva" class="col-sm-4 control-label">Policia Civil</label>
                <div class="col-sm-8">
                  <input id="tipo-impeditiva" type="checkbox" v-model="data.policiaCivil"/>
                </div>
              </div>

              <div class="clearfix"></div>

              <!-- Novo Campo: Seleção de Categorias -->
              <div class="form-group">
                <label class="col-sm-4 control-label">Adicionar Categorias</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="novaCategoriaId">
                    <option disabled value="">Selecione uma categoria</option>
                    <option v-for="categoria in categoriasDisponiveis" :key="categoria.id" :value="categoria.id">
                      {{ categoria.nome }}
                    </option>
                  </select>
                  <button type="button" class="btn btn-primary m-t-xs" @click="adicionarCategoria">Adicionar</button>
                </div>
              </div>

              <!-- Lista de Categorias Selecionadas -->
              <div class="form-group" v-if="Array.isArray(data.categoriaIds) && data.categoriaIds.length">
                <label class="col-sm-4 control-label">Categorias Selecionadas</label>
                <div class="col-sm-8">
                  <ul class="list-group">
                    <li class="list-group-item" v-for="categoriaId in data.categoriaIds" :key="categoriaId">
                      {{ (categoriasDisponiveis.find(c => c.id === categoriaId) || {}).nome || 'Categoria não encontrada' }}
                      <button type="button" class="btn btn-danger btn-xs pull-right" @click="removerCategoria(categoriaId)">
                        Remover
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.bem-equipamento.list'})">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoBemEquipamento.vue?39375ea0